import { ILicenseConsumptionInfo } from '../types/ILicenseConsumptionInfo';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class GetSiteLicensingConsumptionInfoRequest extends Request<{}, ILicenseConsumptionInfo> {
  constructor() {
    super('getSiteLicensingConsumptionInfo', {});
  }
}
